import { useAppSelector } from "../hooks"

export const useSales = () => {
    const { 
        history, 
        loading 
    } = useAppSelector((state) => state.sales);


    return {
        history,
        loading
    };
}